import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles((theme: Theme) => ({
  container: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "#F2F4F7",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Manrope",
  },
  box: {
    width: "90%",
    maxWidth: "1128px",
    backgroundColor: "#fff",
    borderRadius: "20px",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 20px",
  },
  items: {
    maxWidth: "338px",
    height: "auto",
    display: "flex",
    gap: "22px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    marginBottom: "30px",
  },
  icon: {
    width: 56,
    height: 56,
    // backgroundColor: colors.brandBlue50,
    // color: colors.brandBlue500,
    fill: "#000",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontSize: "24px",
    fontWeight: 700,
    textAlign: "center",
    lineHeight: "32px",
    color: colors.brandBlue500,
  },
  content: {
    fontSize: "16px",
    fontWeight: 400,
    textAlign: "center",
    color: colors.gray600,
    letterSpacing: "0.5px",
  },
  closeWindowButton: {
    backgroundColor: colors.brandBlue500,
    padding: "10px 20px",
  },
  invitationDescriptionExpired: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#465869",
    "& > a": {
      textDecoration: "underline",
    },
  },
}));

export default styles;
